import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {login} from 'flows/session/reducer';

import AuthService from '../utils/AuthService';

export class Login extends React.Component {
  componentDidMount() {
    this.auth = new AuthService((authResult) => {
      this.auth.hideLogin();
      this.props.login(authResult);
    });
    this.auth.showLogin();
  }
  render() {
    return (
      <div>
        <img src="/images/ring.svg" alt="Loading" />
      </div>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
};

export default connect(null, {login})(Login);



// WEBPACK FOOTER //
// ./web/containers/Login.js